import cipher7Hint2 from '../../../../assets/images/games/zdar-escape-game/ciphers/7/hint2.webp';
import track7 from '../../../../assets/audio/tracks/track7.mp3';

const hints = [
    {
        text: 'Nevracejte se rozhodně tam odkud ste přišli.',
    },
    {
        image: cipher7Hint2,
    },
];
export const step7falconry = {
    id: 7,
    title: '3. stanoviště',
    taskText: `
        <p>
            Tak co Sokol říká? Hmmm, že prý se máme vydat k nejbarevnějšímu domu v okolí? Vidíš něco? 
        </p>
        <p>
            No jo támhle, tak to je kousek. Až tam budeš klikni na tlačítko "Dále".
        </p>
    `,
    audio: track7,
    snowAudio: track7,
    continueButtonText: 'Dále',
    catImage: 3,
    hints: hints,
    snowHints: hints,
};
